import React from "react";
import {Field} from "react-final-form";
import {
    composeValidators,
    regRequiredValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import {IdLabelInterface} from "../../../../containers/RegistrationLoginPage/types";

import SelectV2 from "../../../HTMLEntities/SelectV2";
import {SINGLE_SELECT} from "../../../HTMLEntities/SelectV2/utils";
import {errorHandler} from "../../../../containers/RegistrationLoginPage/errorUtils";

interface UserIntakeMonthFieldInterface {
    fieldName: string;
    values: IdLabelInterface[] | null;
    selectedValue: IdLabelInterface | null;
    editable: boolean;
}

/**
 * visible: boolean;
    editable: boolean;
    fieldName: string;
    loading: boolean;
    selectedValue: IdLabelInterface | null;
    values: IdLabelInterface[] | null;
 */
const IntakeMonth: React.FC<UserIntakeMonthFieldInterface> = ({
    fieldName,
    values: dropDownValues,
    selectedValue,
    editable,
}: UserIntakeMonthFieldInterface) => {
    return (
        <Field<IdLabelInterface>
            name={fieldName}
            validate={composeValidators(regRequiredValidate("Please select intake month"))}
            {...(selectedValue ? {initialValue: selectedValue} : {})}
            validateFields={[]}
        >
            {(props) => {
                return (
                    <SelectV2
                        placeholder="Intake Month"
                        type={SINGLE_SELECT}
                        items={dropDownValues ?? []}
                        inputRFF={props.input}
                        withSearch={true}
                        isFocused={props?.meta?.active ?? false}
                        isTouched={props?.meta?.touched}
                        error={errorHandler(props?.meta)}
                        isDisabled={!editable}
                        selectedOption={selectedValue ? [selectedValue] : undefined}
                        isFilled={typeof props.input.value === "object"}
                    />
                );
            }}
        </Field>
    );
};
export default IntakeMonth;
